import { useQuery } from '@tanstack/react-query'
import { get } from 'src/utils/http'

export type Org = {
  id?: string
  name: string
  description?: string
  primaryColor?: string
  secondaryColor?: string
  logoUrl?: string
  code?: string
}

export const getGroupAndGroupIdFromDocumentId = (
  documentId: string,
) => {
  const [group] = documentId.split(':')
  const groupId = documentId
    .split(':')
    .slice(1, -1)
    .join(':')

  return [group, groupId]
}

const useOrg = (
  orgId?: string,
): { org?: Org; isLoading: boolean } => {
  const { data: org, isLoading } = useQuery<Org>(
    ['org', orgId],
    () => get(`orgs/${orgId}`),
    {
      enabled: !!orgId,
    },
  )

  return {
    org,
    isLoading,
  }
}

export default useOrg
